import React from "react";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import useStore from "../../../store/useStore";

const formatNotificationTime = (value) => {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return date.toLocaleString("en-IN", {
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const NotificationsSection = () => {
  const { notifications = [], clearNotifications } = useStore();

  return (
    <div>
      <div className="mb-5 flex flex-col gap-3 border-b border-gray-200 pb-4 sm:flex-row sm:items-center sm:justify-between">
        <div>
          <h1 className="text-lg font-semibold text-gray-900">
            Notifications
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            Updates about orders, payments, and offers.
          </p>
        </div>
        {notifications.length > 0 && (
          <button
            type="button"
            onClick={clearNotifications}
            className="rounded-md border border-gray-300 px-3 py-2 text-sm font-semibold text-gray-700 hover:bg-gray-50"
          >
            Clear all
          </button>
        )}
      </div>

      {notifications.length === 0 ? (
        <div className="flex flex-col items-center justify-center rounded-lg border border-dashed border-gray-200 px-4 py-12 text-center">
          <NotificationsNoneOutlinedIcon
            className="text-gray-300"
            style={{ fontSize: 36 }}
          />
          <p className="mt-2 text-sm font-semibold text-gray-700">
            No new notifications
          </p>
          <p className="mt-1 text-sm text-gray-500">You are all caught up.</p>
        </div>
      ) : (
        <div className="divide-y divide-gray-200 rounded-lg border border-gray-200">
          {[...notifications].reverse().map((notification) => (
            <div key={notification.id} className="p-4">
              <div className="flex flex-wrap items-start justify-between gap-2">
                <p className="text-sm font-semibold text-gray-900">
                  {notification.title || "Notification"}
                </p>
                <span className="text-xs text-gray-500">
                  {formatNotificationTime(
                    notification.created_at || notification.id,
                  )}
                </span>
              </div>
              <p className="mt-1 break-words text-sm leading-6 text-gray-600">
                {notification.message}
              </p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default NotificationsSection;
